import { faMedal, faCopy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC, useState } from 'react';
import { Snackbar } from '@material-ui/core';
import { mapDriverCategoryToIconColor } from '../models/ChoferCategoria';
import { ChoferPartialModel } from '../models/Chofer';

interface DriverCanWorkDetailsProps {
  driver: ChoferPartialModel;
  busVehicle?: any;
}

const DriverCanWorkDetails: FC<DriverCanWorkDetailsProps> = ({ driver, busVehicle }) => {
  const vehicleData = busVehicle
    ? {
        modelo: {
          fabricante: { nombre: busVehicle.model?.brand?.name },
          nombre: busVehicle.model?.name
        },
        color: busVehicle.color,
        patente: busVehicle.patent
      }
    : driver.vehiculo;
  const [showCopyNotification, setShowCopyNotification] = useState({
    open: false,
    message: ''
  });

  const formatDriverForWhatsApp = (driver: ChoferPartialModel): string => {
    const lines: string[] = [];

    lines.push(`👨‍✈️ *Chofer:*`);
    lines.push(`Nombre: ${driver.nombreCompleto}`);
    lines.push(`📞 Teléfono: ${driver.phone || '-'}`);
    lines.push('');
    lines.push('🚗 *Vehículo:*');
    if (vehicleData?.modelo?.fabricante?.nombre) {
      lines.push(`• Marca: ${vehicleData.modelo.fabricante.nombre}`);
    }
    if (vehicleData?.modelo?.nombre) {
      lines.push(`• Modelo: ${vehicleData.modelo.nombre}`);
    }
    if (vehicleData?.color) {
      lines.push(`🎨 Color: ${vehicleData.color}`);
    }
    if (vehicleData?.patente) {
      lines.push(`🔢 Patente: ${vehicleData.patente}`);
    }

    return lines.join('\n');
  };

  const handleCopyToClipboard = async () => {
    try {
      const message = formatDriverForWhatsApp(driver);
      await navigator.clipboard.writeText(message);
      setShowCopyNotification({
        open: true,
        message: '✅ Información del chofer copiada al portapapeles'
      });
    } catch (error) {
      console.error('Error al copiar:', error);
      setShowCopyNotification({
        open: true,
        message: '❌ Error al copiar al portapapeles'
      });
    }
  };
  return (
    <>
      <div
        className="flex flex-col gap-4 p-4 shadow-md bg-gray-200 w-full "
        style={{ width: '600px' }}
      >
        {/* Header */}
        <div className="relative text-center bg-white rounded-md space-y-2 p-2">
          <h1 className="text-2xl font-semibold text-gray-800">
            <span className="text-blue-600 font-bold mr-2">
              #{driver.codigo}
            </span>
            {driver.nombreCompleto}
          </h1>
          {/* Teléfono */}
          <div className="text-s flex justify-center">
            <span className="mr-2 font-medium">Teléfono: </span>
            <p className="font-semibold" style={{ color: '#100078' }}>
              {driver.phone}
            </p>
          </div>
          <div
            className="absolute justify-center bg-white"
            style={{ top: '5px', right: '10px' }}
          >
            <FontAwesomeIcon
              icon={faMedal}
              className=""
              size="lg"
              color={mapDriverCategoryToIconColor(driver.categoria)}
            />
          </div>
        </div>
        <div className="text-s grid grid-cols-2 gap-x-6 gap-y-4 bg-white rounded-md space-y-2 px-4 py-2">
          <div>
            <span>Marca: </span>
            <span className="font-semibold" style={{ color: '#100078' }}>
              {vehicleData?.modelo?.fabricante.nombre}
            </span>
          </div>
          <div>
            <span>Modelo: </span>
            <span className="font-semibold" style={{ color: '#100078' }}>
              {vehicleData?.modelo?.nombre}
            </span>
          </div>
          <div>
            <span>Color: </span>
            <span className="font-semibold" style={{ color: '#100078' }}>
              {vehicleData?.color}
            </span>
          </div>
          <div>
            <span>Patente: </span>
            <span
              className="inline-block bg-gray-100 font-semibold tracking-widest uppercase px-3 py-0.5 rounded-md border border-blue-300 shadow-sm text-sm"
              style={{ color: '#100078' }}
            >
              {vehicleData?.patente}
            </span>
          </div>
        </div>

        {/* Botón de copiar */}
        <div className="flex justify-center">
          <div
            onClick={handleCopyToClipboard}
            style={{
              backgroundColor: '#100078',
              color: '#ffffff',
              borderRadius: '8px',
              padding: '10px 20px',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              boxShadow: '0px 0px 8px 0.5px rgba(162, 71, 255, 0.6)',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#100078';
              e.currentTarget.style.boxShadow =
                '0px 0px 8px 1px rgba(166, 0, 199, 0.9)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#100078';
              e.currentTarget.style.boxShadow =
                '0px 0px 8px 0.5px rgba(162, 71, 255, 0.6)';
            }}
          >
            <span>Copiar para Mensaje</span>
            <FontAwesomeIcon icon={faCopy} style={{ fontSize: '16px' }} />
          </div>
        </div>
      </div>

      <Snackbar
        open={showCopyNotification.open}
        autoHideDuration={2000}
        onClose={() => setShowCopyNotification({ open: false, message: '' })}
        message={showCopyNotification.message}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      />
    </>
  );
};

export default DriverCanWorkDetails;
